/* eslint-disable no-unused-vars */
import { useCallback } from 'react';
import * as S from './RightSide.styled';
import { DragDropContext, Droppable, Draggable } from '@hello-pangea/dnd';
import { DraggableItem } from './DraggableItem';

export const RightSide = ({
  rightSideSelectedCols$,
  allColsArr$,
  rightSideSelectedEvents$,
  idToNameObject$,
}) => {
  const onDragColEnd = useCallback((result, allColsArr$, rightSideSelectedCols$) => {
    if (!result.destination) {
      return;
    }
    if (result.destination.index !== result.source.index) {
      const reorderedItems = Array.from(rightSideSelectedCols$.value);
      const [removed] = reorderedItems.splice(result.source.index, 1);
      reorderedItems.splice(result.destination.index, 0, removed);
      const newAllColsArr = [...allColsArr$.value];
      newAllColsArr.forEach((colObj) => {
        const currentColName = colObj.colName;
        const orderIndex = reorderedItems.findIndex((colName) => colName === currentColName);
        if (orderIndex !== -1) {
          colObj.selectedOrder = orderIndex + 1;
        }
      });
      allColsArr$.value = newAllColsArr;
    } else {
      return;
    }
  }, []);
  const onDragEventEnd = useCallback((result, allColsArr$, rightSideSelectedEvents$) => {
    if (!result.destination) {
      return;
    }
    if (result.destination.index !== result.source.index) {
      const reorderedItems = Array.from(rightSideSelectedEvents$.value);
      const [removed] = reorderedItems.splice(result.source.index, 1);
      reorderedItems.splice(result.destination.index, 0, removed);
      const newAllColsArr = Array.from(allColsArr$.value);
      newAllColsArr.forEach((eventObj, index) => {
        const currentEventId = eventObj.eventId;
        const orderIndex = reorderedItems.findIndex((eventId) => eventId === currentEventId);
        if (orderIndex !== -1) {
          const updatedEventObj = {
            ...eventObj,
            orderId: orderIndex,
          };
          newAllColsArr[index] = updatedEventObj;
        }
      });
      allColsArr$.value = newAllColsArr;
    } else {
      return;
    }
  }, []);

  if (rightSideSelectedCols$.value === null || rightSideSelectedEvents$.value === null) {
    return <div>Loading...</div>;
  }

  return (
    <S.Container>
      <DragDropContext
        onDragEnd={(result) => onDragColEnd(result, allColsArr$, rightSideSelectedCols$)}
      >
        <Droppable droppableId='campaignReportDroppable'>
          {(provided, snapshot) => (
            <S.DragDropContainer {...provided.droppableProps} ref={provided.innerRef}>
              <S.Text>Data:</S.Text>
              {rightSideSelectedCols$.value.map((item, index) => (
                <Draggable key={`${item}_${index}`} draggableId={`${item}_${index}`} index={index}>
                  {(provided, snapshot) => (
                    <DraggableItem
                      provided={provided}
                      uniqueId={item}
                      colName={idToNameObject$.value[item]}
                      type='Data'
                    />
                  )}
                </Draggable>
              ))}
              {provided.placeholder}
            </S.DragDropContainer>
          )}
        </Droppable>
      </DragDropContext>
      {rightSideSelectedEvents$.value?.length > 0 && (
        <DragDropContext
          onDragEnd={(result) => onDragEventEnd(result, allColsArr$, rightSideSelectedEvents$)}
        >
          <Droppable droppableId='campaignReportDroppable'>
            {(provided, snapshot) => (
              <S.DragDropContainer {...provided.droppableProps} ref={provided.innerRef}>
                <S.Text>Events:</S.Text>
                {rightSideSelectedEvents$.value.map((item, index) => (
                  <Draggable
                    key={`${item}_${index}`}
                    draggableId={`${item}_${index}`}
                    index={index}
                  >
                    {(provided, snapshot) => (
                      <DraggableItem
                        provided={provided}
                        uniqueId={item}
                        colName={idToNameObject$.value[item]}
                        type='Events'
                      />
                    )}
                  </Draggable>
                ))}
                {provided.placeholder}
              </S.DragDropContainer>
            )}
          </Droppable>
        </DragDropContext>
      )}
    </S.Container>
  );
};
